import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

//E-commerce
import ecommerce from "./e-commerce/reducer"

//Calendar
import calendar from "./calendar/reducer"

//chat
import chat from "./chat/reducer"

//crypto
import crypto from "./crypto/reducer"

//invoices
import invoices from "./invoices/reducer"

//jobs
import JobReducer from "./jobs/reducer"

//projects
import projects from "./projects/reducer"

//tasks
import tasks from "./tasks/reducer"

//contacts
import contacts from "./contacts/reducer"

//mails
import mails from "./mails/reducer"

//Dashboard
import Dashboard from "./dashboard/reducer"

//Dasboard saas
import DashboardSaas from "./dashboard-saas/reducer"
//Dasboard saas

import Users from "./user/reducer"

import branches from "./branch-resource/reducer"
import company from "./company-resource/reducer"
import customer from "./customer-resource/reducer"
import rtwProduct from "./rtw-product-resource/reducer"
import rtwImage from "./rtw-image-resource/reducer"
import seasonPage from "./season-resource/reducer"
import dimension from "./dimension-resource/reducer"
import correction from "./correction-resource/reducer"

import fabricTreding from "./fabric-trading-company-resource/reducer"
import fabric from "./fabric-resource/reducer"

import season from "./season/reducer"

import productCategory from "./product-category/reducer"
import products from "./products/reducer"
import specification from "./specification/reducer"
import infoMe from "./me-resource/reducer"
import attendance from "./attendance-resource/reducer"
import staff from "./staff-resource/reducer"
import assignment from "./assignment-resource/reducer"
import inspection from "./inspection-resource/reducer"
import productionSummary from "./production-summary/reducer"
import fabricOrder from "./fabric-order-resource/reducer"
import common from "./common-resource/reducer"
import fabricInventory from "./fabric-inventory-resource/reducer"
import rtwInventory from "./rtw-inventory/reducer"
import orderSheetCanvas from "./canvas/reducer"
import rtwCanvas from "./rtw-canvas/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ecommerce,
  calendar,
  chat,
  mails,
  crypto,
  invoices,
  JobReducer,
  projects,
  tasks,
  contacts,
  Dashboard,
  DashboardSaas,
  Users,
  branches,
  company,
  customer,
  fabricTreding,
  fabric,
  season,
  productCategory,
  products,
  specification,
  rtwProduct,
  rtwImage,
  seasonPage,
  dimension,
  correction,
  infoMe,
  attendance,
  staff,
  assignment,
  inspection,
  productionSummary,
  fabricOrder,
  common,
  fabricInventory,
  rtwInventory,
  orderSheetCanvas,
  rtwCanvas,
})

export default rootReducer
